export default function isCacheLike(cache) {
    return typeof cache.get === 'function' && typeof cache.set === 'function' && (typeof cache.delete === 'function' || typeof cache.del === 'function');
}
//# sourceMappingURL=isCacheLike.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios-extensions/esm/utils/isCacheLike.js
// module id = 530
// module chunks = 0